import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from './getFlowKey';
const FLOW_TO_BACKEND_KEY = {
  [Flow.AeoStandalone]: 'aeo-standalone'
};
export const getBackendFlowKey = () => {
  const flowKey = getFlowKey();
  return FLOW_TO_BACKEND_KEY[flowKey] || flowKey;
};